import { useContext, useEffect, useMemo, useRef, useState } from "react";
import {
  DataGridPro,
  GridToolbarContainer,
} from "@mui/x-data-grid-pro";
import { Skeleton, TextField } from "@mui/material";
import { FaCircle } from "react-icons/fa";
import {
  HiOutlineCheck,
  HiOutlineUser,
  HiOutlineArrowPath,
  HiOutlineClipboard,
  HiOutlineUsers,
  HiOutlineDocumentText,
  HiOutlinePaperAirplane,
  HiOutlineBuildingOffice,
  HiOutlineCurrencyEuro,
} from "react-icons/hi2";
import { useLocation, useNavigate } from "react-router-dom";
import { Input } from "../components/Input";
import { StatoFatturazione } from "../components/StatoFatturazione";
import { Amministratore } from "../utility/useAmministraotre";
import api from "../components/api/api";
import moment from "moment";
import { Modal } from "../components/Modal";
import { toast } from "react-toastify";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import "moment/locale/it";
import { HiOutlineMail } from "react-icons/hi";
import { ModalXL } from "../components/ModalXL";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const compareRiferimento = (value1, value2, cellParams1, cellParams2) => {
  const year1 = cellParams1?.row?.data_esercizio
    ? Number(moment(cellParams1.row.data_esercizio).format("YYYY"))
    : 0;
  const year2 = cellParams2?.row?.data_esercizio
    ? Number(moment(cellParams2.row.data_esercizio).format("YYYY"))
    : 0;
  const rif1 = Number(cellParams1?.row?.riferimento) || 0;
  const rif2 = Number(cellParams2?.row?.riferimento) || 0;

  if (year1 !== year2) return year1 - year2;
  return rif1 - rif2;
};

const sortSinistriByAnnoRiferimento = (list) =>
  [...(list || [])].sort((a, b) => {
    const yearA = a?.data_esercizio
      ? Number(moment(a.data_esercizio).format("YYYY"))
      : 0;
    const yearB = b?.data_esercizio
      ? Number(moment(b.data_esercizio).format("YYYY"))
      : 0;
    if (yearA !== yearB) return yearB - yearA;
    const rifA = Number(a?.riferimento) || 0;
    const rifB = Number(b?.riferimento) || 0;
    return rifB - rifA;
  });

const filterCondominialiData = (list, flags) => {
  const base = Array.isArray(list) ? list : [];
  const filtered = base.filter((row) => {
    if (!flags?.pagate && row.stato === 1) return false;
    if (!flags?.nonPagate && row.stato !== 1) return false;
    return true;
  });
  return sortSinistriByAnnoRiferimento(filtered);
};

const formatEuro = (value) => {
  const num = Number(value);
  if (Number.isNaN(num)) return "";
  return new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
  }).format(num);
};

const columns = [
  {
    field: "nome",
    headerName: "Impresa",
    width: 250,
    editable: false,
    align: "center",
    headerAlign: "center",
  },
];

const columnsCondominiali = [
  {
    field: "*",
    headerName: "Stato",
    width: 80,
    editable: false,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => {
      return (
        <div className="w-full h-full flex items-center justify-center">
          <FaCircle
            className={`text-3xl`}
            color={params.row.stato === 1 ? "green" : "red"}
          />
        </div>
      );
    },
  },
  {
    field: "riferimento",
    headerName: "Sinistro",
    width: 350,
    editable: false,
    align: "left",
    headerAlign: "center",
    valueGetter: ({ row }) => {
      const riferimento = row?.riferimento ?? "";
      const year = row?.data_esercizio
        ? moment(row?.data_esercizio).format("YY")
        : "";
      return `${riferimento}/${year}`;
    },
    sortComparator: compareRiferimento,
    renderCell: (params) => {
      let riferimento = params.row?.riferimento;
      let data = params.row?.data_esercizio
        ? moment(params.row?.data_esercizio).format("YY") + " "
        : "";
      let condominio =
        params.row?.condominio !== "" ? params.row?.condominio + " " : "";
      let danno = params.row?.danno !== "" ? params.row?.danno + " " : "";
      let persone = params.row?.persone ? params.row?.persone : "";
      return (
        <>
          {riferimento +
            "/" +
            data +
            " " +
            condominio +
            " " +
            danno +
            " " +
            persone}
        </>
      );
    },
  },
  {
    field: "intervento",
    headerName: "Intervento",
    width: 150,
    editable: false,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "fattura",
    headerName: "Importo",
    width: 100,
    editable: false,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => {
      const fatturaFix = formatEuro(params.row?.fattura);
      return <>{fatturaFix}</>;
    }
  },
  {
    field: "anno",
    headerName: "Anno",
    width: 70,
    editable: false,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "n_fattura",
    headerName: "N° Fattura",
    width: 100,
    editable: false,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "dettaglio_pagamento",
    headerName: "Dettaglio Pagamento",
    width: 150,
    editable: false,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "codice_fattura",
    headerName: "Codice Fattura",
    width: 150,
    editable: false,
    align: "center",
    headerAlign: "center",
  },
];
const columnsSinistri = [
  {
    field: "*",
    headerName: "Stato",
    width: 80,
    editable: false,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => {
      return (
        <div className="w-full h-full flex items-center justify-center">
          <FaCircle
            className={`text-3xl`}
            color={params.row.stato === 1 ? "green" : "red"}
          />
        </div>
      );
    },
  },
  {
    field: "riferimento",
    headerName: "Sinistro",
    width: 250,
    editable: false,
    align: "left",
    headerAlign: "center",
    valueGetter: ({ row }) => {
      const riferimento = row?.riferimento ?? "";
      const year = row?.data_esercizio
        ? moment(row?.data_esercizio).format("YY")
        : "";
      return `${riferimento}/${year}`;
    },
    sortComparator: compareRiferimento,
    renderCell: (params) => {
      let riferimento = params.row?.riferimento;
      let data = params.row?.data_esercizio
        ? moment(params.row?.data_esercizio).format("YY") + " "
        : "";
      let condominio =
        params.row?.condominio !== "" ? params.row?.condominio + " " : "";
      let danno = params.row?.danno !== "" ? params.row?.danno + " " : "";
      let persone = params.row?.persone ? params.row?.persone : "";
      return (
        <div className="text-left w-full">
          {riferimento +
            "/" +
            data +
            " " +
            condominio +
            " " +
            danno +
            " " +
            persone}
        </div>
      );
    },
  },

  {
    field: "intervento",
    headerName: "Intervento",
    width: 150,
    editable: false,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "fattura",
    headerName: "Importo",
    width: 100,
    editable: false,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => {
      const fatturaFix = formatEuro(params.row?.fattura);
      return <>{fatturaFix}</>;
    }
  },
  {
    field: "anno",
    headerName: "Anno",
    width: 70,
    editable: false,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "n_fattura",
    headerName: "N° Fattura",
    width: 100,
    editable: false,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "dettaglio_pagamento",
    headerName: "Dettaglio",
    width: 200,
    editable: false,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "codice_fattura",
    headerName: "Codice Fattura",
    width: 150,
    editable: false,
    align: "center",
    headerAlign: "center",
  },
];

export const Pagamenti = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [condominiali, setCondominiali] = useState(false);
  const [da, setDa] = useState(moment(new Date()).subtract(12, "month"));
  const [a, setA] = useState(new Date());
  const [filtroCondominiali, setFiltroCondominiali] = useState({
    pagate: false,
    nonPagate: true,
  });

  const [amministratore, setAmministratore] = useContext(Amministratore);
  const [pagamenti, setPagamenti] = useState([]);
  const [pagamentiBk, setPagamentiBk] = useState([]);
  const [quickSearch, setQuickSearch] = useState("");
  const quickSearchRef = useRef(null);

  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedSinistri, setSelectedSinistri] = useState([]);
  const [open, setOpen] = useState(false);
  const [pagamentoMassivo, setPagamentoMassivo] = useState({
    stato: 0,
    codice_fattura: "",
    dettaglio_pagamento: "",
  });
  const [massive, setMassive] = useState(false);
  const [sinistroSelected, setSinistroSelected] = useState(null);

  const [openEmail, setOpenEmail] = useState(false);
  const [sending, setSending] = useState(false);
  const [mail, setMail] = useState({
    mittente: "",
    alias: "",
    password: "",
    destinatari: "",
    copia: "",
    copiaNascosta: "",
    oggetto: "",
    testo: "",
    firma: "",
  });

  const [table, setTable] = useState([]);

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <div className="w-full flex justify-between">
          <div className="flex items-center flex-1 mb-2 gap-3">
            <div className="w-full max-w-xs">
              <input
                className="w-full h-[38px] px-3 border rounded-md"
                placeholder="Cerca..."
                value={quickSearch}
                onChange={(e) => {
                  const v = e.target.value;
                  setQuickSearch(v);
                  requestAnimationFrame(() => {
                    quickSearchRef.current?.focus({ preventScroll: true });
                  });
                }}
                ref={quickSearchRef}
              />
            </div>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                format="YYYY-MM"
                views={["year", "month"]}
                label="Da"
                value={moment(da)}
                onChange={(e) => {
                  setDa(e);
                }}
                slotProps={{
                  textField: { size: "small", helperText: null },
                }}
              />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                format="YYYY-MM"
                views={["year", "month"]}
                label="A"
                value={moment(a)}
                onChange={(e) => {
                  setA(e);
                }}
                slotProps={{
                  textField: { size: "small", helperText: null },
                }}
              />
            </LocalizationProvider>
            <div className="flex gap-2">
              <div className="icon-container-green group " onClick={loadData}>
                <HiOutlineArrowPath className="icon-green" />
              </div>
              <div
                className="icon-container-green group "
                onClick={loadCondominiali}
              >
                <HiOutlineBuildingOffice className="icon-green" />
              </div>
            </div>
          </div>
          <div className="flex gap-2 items-center">
            {selectedIds?.length > 0 && (
              <>
                <div className="icon-container-blue group" onClick={checkEmail}>
                  <HiOutlineMail className="icon-blue" />
                </div>
                <div
                  className="icon-container-blue group h-min"
                  onClick={() => {
                    setMassive(true);
                    setOpen(true);
                  }}
                >
                  <HiOutlineCurrencyEuro className="icon-blue" />
                </div>
              </>
            )}
          </div>
        </div>
      </GridToolbarContainer>
    );
  }

  function CustomToolbarCondominiali() {
    return (
      <GridToolbarContainer>
        <div className="flex items-center justify-between w-full mb-2">
          <div className="flex items-center gap-3">
            <div className="w-full max-w-xs">
              <input
                className="w-full h-[38px] px-3 border rounded-md"
                placeholder="Cerca..."
                value={quickSearch}
                onChange={(e) => {
                  const v = e.target.value;
                  setQuickSearch(v);
                  requestAnimationFrame(() => {
                    quickSearchRef.current?.focus({ preventScroll: true });
                  });
                }}
                ref={quickSearchRef}
              />
            </div>
            <div className="flex items-center py-2 px-3 rounded-md relative cursor-pointer">
              <input
                type="checkbox"
                name={"pagate"}
                className="h-4 w-4  placeholder:text-black"
                checked={filtroCondominiali.pagate}
                onChange={handleCheckboxCondominiali}
              />
              <span className="text-base font-normal ml-2 whitespace-nowrap">
                Pagate
              </span>
            </div>
            <div className="flex items-center py-2 px-3 rounded-md relative cursor-pointer">
              <input
                type="checkbox"
                name={"nonPagate"}
                className="h-4 w-4  placeholder:text-black"
                checked={filtroCondominiali.nonPagate}
                onChange={handleCheckboxCondominiali}
              />
              <span className="text-base font-normal ml-2 whitespace-nowrap">
                Non Pagate
              </span>
            </div>
          </div>
          <div className="flex gap-2 items-center">
            {selectedIds?.length > 0 && (
              <>
                <div className="icon-container-blue group" onClick={checkEmail}>
                  <HiOutlineMail className="icon-blue" />
                </div>
                <div
                  className="icon-container-blue group h-min"
                  onClick={() => {
                    setMassive(true);
                    setOpen(true);
                  }}
                >
                  <HiOutlineCurrencyEuro className="icon-blue" />
                </div>
              </>
            )}
          </div>
        </div>
      </GridToolbarContainer>
    );
  }
  const handleChangeMail = (e) => {
    setMail({ ...mail, [e.target.name]: e.target.value });
  };
  const handleCheckboxCondominiali = (e) => {
    const updated = { ...filtroCondominiali, [e.target.name]: e.target.checked };
    setFiltroCondominiali(updated);
    setPagamenti(filterCondominialiData(pagamentiBk, updated));
  };

  const handleInputChange = (e, rowIndex, field) => {
    const updatedTable = [...table];
    updatedTable[rowIndex][field] = e.target.value;
    setTable(updatedTable);
  };

  const filteredPagamenti = useMemo(() => {
    const needle = quickSearch.toLowerCase();
    if (!needle) return pagamenti;

    const rowMatches = (row) => {
      const flat = [];
      const pushVal = (val) => {
        if (val === null || val === undefined) return;
        if (Array.isArray(val)) return val.forEach(pushVal);
        if (typeof val === "object") return; // skip nested objects
        flat.push(String(val));
      };
      Object.values(row || {}).forEach(pushVal);
      // aggiungi riferimento formattato come in griglia
      if (row?.riferimento && row?.data_esercizio) {
        const yy = moment(row.data_esercizio).format("YY");
        const rifFormatted = `${row.riferimento}/${yy}`;
        flat.push(rifFormatted);
        // Colonna "Sinistro" mostra anche condominio/danno/persone: indicizzala
        const cond = row?.condominio ? row.condominio : "";
        const dan = row?.danno ? row.danno : "";
        const pers = row?.persone ? row.persone : "";
        flat.push(`${rifFormatted} ${cond} ${dan} ${pers}`);
      }
      return flat.join(" ").toLowerCase().includes(needle);
    };

    return pagamenti?.filter(rowMatches);
  }, [pagamenti, quickSearch]);

  const checkEmail = async () => {
    //DATI BASE
    let responseTestoEmail = await api.get("tipologie_mail/" + "Pagamento");
    let responseAmministratori = await api.get("amministratori");
    let amm = responseAmministratori.data.data?.filter(
      (el) => el.id === amministratore
    )[0];
    let responseEmailAmministratori = await api.get(
      "amministratori/referente/" + amm?.id
    );
    let responseUtenti = await api.get(
      "utenti/" + sessionStorage.getItem("Username")
    );

    //DATI LAVORI IMPRESE
    let destinatari = responseEmailAmministratori.data.data
      ?.filter((responsabili) => responsabili.principale === 1)
      .map((res) => res.email);
    let tableData = selectedSinistri?.map((lavoro) => {
      let imp = "";
      imp =
        (lavoro?.n_fattura ? "FATT " + lavoro?.n_fattura + " " : "") +
        (lavoro?.fattura ? lavoro?.fattura + "€" : "");
      let pers = lavoro?.persone ? lavoro?.persone?.split(",") : "";
      if (pers?.length >= 3) {
        pers = pers?.slice(0, 3);
      }
      pers =
        (lavoro?.danno ? lavoro?.danno + ", " : "") +
        (pers && pers?.join(", "));
        let data = lavoro?.data_esercizio
        ? moment(lavoro?.data_esercizio).format("YY") + " "
        : "";
      let row = {
        riferimento:
          lavoro?.riferimento +
          "/" +
          data,
        condominio: lavoro?.condominio,
        impresa: imp,
        persone: pers,
      };

      return row;
    });
    setTable(tableData);

    setMail({
      ...mail,
      mittente: amm?.email ? amm.email : "",
      alias: amm?.alias_check === 1 ? amm?.alias : "",
      password: amm?.password_email ? amm.password_email : "",
      destinatari: destinatari,
      copiaNascosta: responseUtenti.data?.data[0]?.copia_nascosta,
      firma: amm.firma ? amm.firma : "",
      oggetto: "Fatturazione",
      testo: responseTestoEmail.data.data[0]?.testo,
    });
    setOpenEmail(true);
  };

  const handleSendEmail = async () => {
    if (mail.destinatari) {
      setSending(true);
      try {
        await api.post("email/pagamenti/", {
          mittente: mail.mittente,
          alias: mail.alias,
          password: mail.password,
          destinatari: mail.destinatari,
          copia: mail?.copia,
          copiaNascosta: mail?.copiaNascosta,
          oggetto: mail.oggetto,
          testo: mail?.testo,
          table: table,
          firma: mail.firma,
          allegati: mail?.allegati ? [mail?.allegati] : "",
          utente: sessionStorage.getItem("Username"),
          tipologia: "Pagamento",
        });
        toast.success("Email inviata!");
      } catch (error) {
        toast.error("Errore durante l'invio!");
      }
      setSending(false);
    } else {
      toast.error("Campo Destinatari obbligatoro!");
    }
  };

  const loadCondominiali = async () => {
    setLoading(true);
    const urlParams = new URLSearchParams();
    urlParams.append("da", moment(da).format("YYYY-MM-DD"));
    urlParams.append("a", moment(a).format("YYYY-MM-DD"));
    urlParams.append("pagante", 2);
    let responseImprese;
    if (amministratore !== 0) {
      urlParams.append("id", amministratore);
      responseImprese = await api.get("pagamenti/condominiale", {
        params: urlParams,
      });
    } else {
      urlParams.append("all", true);
      responseImprese = await api.get("pagamenti/condominiale", {
        params: urlParams,
      });
    }
    const sorted = sortSinistriByAnnoRiferimento(responseImprese.data.data);
    setPagamentiBk(sorted);
    setPagamenti(filterCondominialiData(sorted, filtroCondominiali));
    setCondominiali(true);
    setLoading(false);
  };

  const handleClose = () => {
    setOpen(false);
    setMassive(false);
    setSelectedIds([]);
    setPagamentoMassivo({
      stato: 0,
      codice_fattura: "",
    });
  };

  const handleSave = async () => {
    try {
      await api.put("imprese/pagamento", {
        impresa: sinistroSelected,
      });
      toast.success("Modifica completata!");
      handleClose();
      loadCondominiali();
    } catch (error) {
      console.error("handleSave -> error", error);
      toast.error("Errore durante la modifica. Riprova!");
    }
  };

  const massiveUpdate = async () => {
    try {
      let response = await api.put("imprese/rel", {
        ids: selectedIds,
        pagamento: pagamentoMassivo,
      });
      toast.success(`Pagamenti aggiornati ${response.data.affectedRows}!`);
      handleClose();
      loadCondominiali();
    } catch (error) {
      console.error("massiveUpdate -> error", error);
      toast.error("Errore durante la modifica. Riprova!");
    }
  };

  const loadData = async () => {
    setLoading(true);
    setCondominiali(false);
    const urlParams = new URLSearchParams();
    urlParams.append("da", moment(da).format("YYYY-MM-DD"));
    urlParams.append("a", moment(a).format("YYYY-MM-DD"));
    urlParams.append("pagante", 1);
    let responseImprese;
    if (amministratore !== 0) {
      urlParams.append("id", amministratore);
      responseImprese = await api.get("pagamenti", { params: urlParams });
    } else {
      responseImprese = await api.get("pagamenti/all", { params: urlParams });
    }
    setPagamenti(responseImprese.data.data);
    setLoading(false);
  };

  useEffect(() => {
    (async () => {
      loadData();
    })();
  }, []);

  return (
    <div className="page-container ">
      <div className="w-full container-box h-full">
        {!loading ? (
          <>
            {!condominiali ? (
              <DataGridPro
                ignoreDiacritics
                rows={filteredPagamenti}
                columns={columns}
                getRowId={(row) => row.id}
                initialState={{
                  sorting: {
                    sortModel: [
                      { field: "riferimento", sort: "desc" },
                    ],
                  },
                }}
                slots={{ toolbar: CustomToolbar }}
                onRowClick={(row) => {
                  navigate("/Dettaglio-Pagamento", {
                    state: {
                      pagamento: row.row,
                      da: moment(da).format("YYYY-MM-DD"),
                      a: moment(a).format("YYYY-MM-DD"),
                    },
                  });
                }}
                disableRowSelectionOnClick
              />
            ) : (
              <DataGridPro
                ignoreDiacritics
                rows={filteredPagamenti}
                columns={columnsCondominiali}
                getRowId={(row) => row.id}
                initialState={{
                  sorting: {
                    sortModel: [
                      { field: "riferimento", sort: "desc" },
                    ],
                  },
                }}
                slots={{ toolbar: CustomToolbarCondominiali }}
                onRowClick={(row) => {
                  setSinistroSelected({ ...row.row });
                  setOpen(true);
                  setMassive(false);
                }}
                checkboxSelection
                rowSelectionModel={selectedIds}
                onRowSelectionModelChange={(ids) => {
                  const selectedIDs = new Set(ids);
                  setSelectedIds(ids);
                  const selectedRowData = pagamenti.filter((row) =>
                    selectedIDs.has(row.id)
                  );
                  setSelectedSinistri(selectedRowData);
                }}
                disableRowSelectionOnClick
              />
            )}
            <ModalXL open={openEmail} handleClose={() => setOpenEmail(false)}>
              <div className="grid grid-cols-2 gap-2 h-full px-2">
                <div className="col-span-2 text-2xl text-center">
                  Invio Pagamenti
                </div>
                <div className="col-span-2">
                  <Input
                    label={"Mittente"}
                    type="text"
                    name="mittente"
                    onChange={handleChangeMail}
                    value={mail?.mittente}
                    icon={<HiOutlineUser className="text-2xl" />}
                  />
                </div>
                {mail?.alias && (
                  <div className="col-span-2">
                    <Input
                      label={"Alias"}
                      type="text"
                      name="alias"
                      onChange={handleChangeMail}
                      value={mail?.alias}
                      icon={<HiOutlineUser className="text-2xl" />}
                    />
                  </div>
                )}
                <div className="col-span-2">
                  <Input
                    label={"Destinatari"}
                    type="text"
                    name="destinatari"
                    onChange={handleChangeMail}
                    value={mail?.destinatari}
                    icon={<HiOutlineUser className="text-2xl" />}
                  />
                </div>
                <div className="col-span-2">
                  <Input
                    label={"In Copia"}
                    type="text"
                    name="copia"
                    onChange={handleChangeMail}
                    value={mail?.copia}
                    icon={<HiOutlineUsers className="text-2xl" />}
                  />
                </div>
                <div className="col-span-2">
                  <Input
                    label={"In Copia Nascosta"}
                    type="text"
                    name="copiaNascosta"
                    onChange={handleChangeMail}
                    value={mail?.copiaNascosta}
                    icon={<HiOutlineUsers className="text-2xl" />}
                  />
                </div>
                <div className="col-span-2">
                  <Input
                    label={"Oggetto"}
                    type="text"
                    name="oggetto"
                    onChange={handleChangeMail}
                    value={mail?.oggetto}
                    icon={<HiOutlineUsers className="text-2xl" />}
                  />
                </div>
                <div className="col-span-2 ">
                  <span className="text-lg font-normal">Testo</span>
                  <div className="relative">
                    <span className="absolute left-2 flex items-start pr-2 pt-2 h-full">
                      <HiOutlineDocumentText className="text-2xl" />
                    </span>

                    <textarea
                      rows={2}
                      type="text"
                      name="testo"
                      className="input flex items-center"
                      placeholder="Inserisci Testo"
                      onChange={handleChangeMail}
                      value={mail?.testo}
                    />
                  </div>
                </div>
                <div className="col-span-2">
                  <span className="text-lg font-normal">Tabella</span>
                  <table className="w-full ">
                    <thead>
                      <tr>
                        <th className="border border-black">Riferimento</th>
                        <th className="border border-black">Condominio</th>
                        <th className="border border-black">Impresa</th>
                        <th className="border border-black">Persone</th>
                      </tr>
                    </thead>
                    <tbody>
                      {table?.map((t, rowIndex) => (
                        <tr
                          key={rowIndex}
                          className="border border-black h-full"
                        >
                          <td className="border border-black">
                            <input
                              type="text"
                              className="text-center w-full"
                              value={t.riferimento}
                              onChange={(e) =>
                                handleInputChange(e, rowIndex, "riferimento")
                              }
                            />
                          </td>
                          <td className="border border-black">
                            <input
                              className="text-center w-full"
                              type="text"
                              value={t.condominio}
                              onChange={(e) =>
                                handleInputChange(e, rowIndex, "condominio")
                              }
                            />
                          </td>
                          <td className="border border-black">
                            <textarea
                              type="text"
                              className="text-center w-full"
                              value={t.impresa}
                              onChange={(e) =>
                                handleInputChange(e, rowIndex, "impresa")
                              }
                            />
                          </td>
                          <td className="border border-black">
                            <textarea
                              type="text"
                              className="text-center w-full"
                              value={t.persone}
                              onChange={(e) =>
                                handleInputChange(e, rowIndex, "persone")
                              }
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="col-span-2 flex gap-4 items-center justify-end flex-1 mt-6">
                  {sending ? (
                    <div
                      className="icon-container-green group "
                      onClick={() => toast.warning("Invio in corso!")}
                    >
                      <AiOutlineLoading3Quarters className="icon-green animate-spin" />
                    </div>
                  ) : (
                    <div
                      className="icon-container-green h-min group "
                      onClick={handleSendEmail}
                    >
                      <HiOutlinePaperAirplane className="icon-green" />
                    </div>
                  )}
                </div>
              </div>
            </ModalXL>
            <Modal open={open} handleClose={handleClose}>
              <div className="grid grid-cols-2 gap-2">
                <div className="col-span-2 text-2xl text-center">Pagamento</div>
                <div className="col-span-2 ">
                  <StatoFatturazione
                    onChange={(val) => {
                      setSinistroSelected({
                        ...sinistroSelected,
                        stato: val,
                      });
                      setPagamentoMassivo({
                        ...pagamentoMassivo,
                        stato: val,
                      });
                    }}
                    value={
                      massive
                        ? pagamentoMassivo?.stato
                        : sinistroSelected?.stato
                    }
                    label={"Stato"}
                  />
                </div>
                {massive ? (
                  <div className="col-span-4 md:col-span-2 ">
                    <Input
                      label={"Codice Fattura"}
                      type="text"
                      name="codice_fattura"
                      onChange={(e) => {
                        setPagamentoMassivo({
                          ...pagamentoMassivo,
                          codice_fattura: e.target.value,
                        });
                      }}
                      value={pagamentoMassivo?.codice_fattura}
                      icon={<HiOutlineCurrencyEuro className="text-2xl" />}
                    />
                  </div>
                ) : (
                  <>
                    <div className="col-span-4 md:col-span-2 ">
                      <Input
                        label={"Codice Fattura"}
                        type="text"
                        name="codice_fattura"
                        onChange={(e) => {
                          setSinistroSelected({
                            ...sinistroSelected,
                            codice_fattura: e.target.value,
                          });
                        }}
                        value={sinistroSelected?.codice_fattura}
                        icon={<HiOutlineCurrencyEuro className="text-2xl" />}
                      />
                    </div>
                    <div className="col-span-4 md:col-span-2 ">
                      <Input
                        label={"Dettaglio Pagamento"}
                        type="text"
                        name="dettaglio_pagamento"
                        onChange={(e) => {
                          setSinistroSelected({
                            ...sinistroSelected,
                            dettaglio_pagamento: e.target.value,
                          });
                        }}
                        value={sinistroSelected?.dettaglio_pagamento}
                        icon={<HiOutlineClipboard className="text-2xl" />}
                      />
                    </div>
                  </>
                )}
                <div className="col-span-2 flex gap-4 items-center justify-end flex-1 mt-6">
                  <div
                    className="icon-container-green h-min group "
                    onClick={massive ? massiveUpdate : handleSave}
                  >
                    <HiOutlineCheck className="icon-green" />
                  </div>
                </div>
              </div>
            </Modal>
          </>
        ) : (
          <div className="flex flex-wrap gap-2">
            <div className="flex w-full gap-2">
              <Skeleton variant="rounded" width={70} height={70} />
              <Skeleton variant="rounded" width="90%" height={70} />
            </div>
            <div className="flex w-full gap-2">
              <Skeleton variant="rounded" width={70} height={70} />
              <Skeleton variant="rounded" width="90%" height={70} />
            </div>
            <div className="flex w-full gap-2">
              <Skeleton variant="rounded" width={70} height={70} />
              <Skeleton variant="rounded" width="90%" height={70} />
            </div>
            <div className="flex w-full gap-2">
              <Skeleton variant="rounded" width={70} height={70} />
              <Skeleton variant="rounded" width="90%" height={70} />
            </div>
            <div className="flex w-full gap-2">
              <Skeleton variant="rounded" width={70} height={70} />
              <Skeleton variant="rounded" width="90%" height={70} />
            </div>
            <div className="flex w-full gap-2">
              <Skeleton variant="rounded" width={70} height={70} />
              <Skeleton variant="rounded" width="90%" height={70} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export const DettaglioPagamento = () => {
  const location = useLocation();

  const [amministratore, setAmministratore] = useContext(Amministratore);

  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedSinistri, setSelectedSinistri] = useState([]);
  const [sinistri, setSinistri] = useState([]);
  const [sinistriBk, setSinistriBk] = useState([]);
  const [open, setOpen] = useState(false);
  const [massive, setMassive] = useState(false);
  const [pagamentoMassivo, setPagamentoMassivo] = useState({
    stato: 0,
    codice_fattura: "",
  });
  const [sinistroSelected, setSinistroSelected] = useState(null);

  const [openEmail, setOpenEmail] = useState(false);
  const [sending, setSending] = useState(false);
  const [filtro, setFiltro] = useState({ pagate: false, nonPagate: true });
  const [filtroCondominiali, setFiltroCondominiali] = useState({
    pagate: true,
    nonPagate: true,
  });
  const [mail, setMail] = useState({
    mittente: "",
    alias: "",
    password: "",
    destinatari: "",
    copia: "",
    copiaNascosta: "",
    oggetto: "",
    testo: "",
    firma: "",
  });

  const [table, setTable] = useState([]);
  const [sortModelPagamenti, setSortModelPagamenti] = useState([
    { field: "riferimento", sort: "desc" },
  ]);
  const [quickSearch, setQuickSearch] = useState("");
  const quickSearchRef = useRef(null);
  const filteredSinistri = useMemo(() => {
    const needle = quickSearch.toLowerCase();
    if (!needle) return sinistri;

    const rowMatches = (row) => {
      const flat = [];
      const pushVal = (val) => {
        if (val === null || val === undefined) return;
        if (Array.isArray(val)) return val.forEach(pushVal);
        if (typeof val === "object") return; // skip nested objects
        flat.push(String(val));
      };
      Object.values(row || {}).forEach(pushVal);
      if (row?.riferimento && row?.data_esercizio) {
        const yy = moment(row.data_esercizio).format("YY");
        const rifFormatted = `${row.riferimento}/${yy}`;
        flat.push(rifFormatted);
        const cond = row?.condominio ? row.condominio : "";
        const dan = row?.danno ? row.danno : "";
        const pers = row?.persone ? row.persone : "";
        flat.push(`${rifFormatted} ${cond} ${dan} ${pers}`);
      }
      return flat.join(" ").toLowerCase().includes(needle);
    };

    return sinistri?.filter(rowMatches);
  }, [sinistri, quickSearch]);

  const handleChangeMail = (e) => {
    setMail({ ...mail, [e.target.name]: e.target.value });
  };
  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <div className="flex items-center justify-between w-full mb-2">
          <div className="flex">
            <div className="w-full max-w-xs">
              <input
                className="w-full h-[38px] px-3 border rounded-md"
                placeholder="Cerca..."
                value={quickSearch}
                onChange={(e) => {
                  const v = e.target.value;
                  setQuickSearch(v);
                  requestAnimationFrame(() => {
                    quickSearchRef.current?.focus({ preventScroll: true });
                  });
                }}
                ref={quickSearchRef}
              />
            </div>
            <div className="flex items-center py-2 px-3 rounded-md relative cursor-pointer">
              <input
                type="checkbox"
                name={"pagate"}
                className="h-4 w-4  placeholder:text-black"
                checked={filtro?.pagate}
                onChange={handleCheckbox}
              />
              <span
                htmlFor="default-checkbox"
                className="text-base font-normal ml-2 whitespace-nowrap"
              >
                Pagate
              </span>
            </div>
            <div className="flex items-center py-2 px-3 rounded-md relative cursor-pointer">
              <input
                type="checkbox"
                name={"nonPagate"}
                className="h-4 w-4  placeholder:text-black"
                checked={filtro?.nonPagate}
                onChange={handleCheckbox}
              />
              <span
                htmlFor="default-checkbox"
                className="text-base font-normal ml-2 whitespace-nowrap"
              >
                Non Pagate
              </span>
            </div>
            {/* <Checkbox
              label={"Pagate"}
              nome={"pagate"}
              value={filtro?.pagate}
              onChange={handleCheckbox}
            />
            <Checkbox
              label={"Pagate"}
              nome={"pagate"}
              value={filtro?.pagate}
              onChange={handleCheckbox}
            /> */}
          </div>

          {selectedIds?.length > 0 && (
            <div className="flex gap-2">
              <div className="icon-container-blue group" onClick={checkEmail}>
                <HiOutlineMail className="icon-blue" />
              </div>
              <div
                className="icon-container-blue group"
                onClick={() => {
                  setMassive(true);
                  setOpen(true);
                }}
              >
                <HiOutlineCurrencyEuro className="icon-blue" />
              </div>
            </div>
          )}
        </div>
      </GridToolbarContainer>
    );
  }

  const massiveUpdate = async () => {
    try {
      let response = await api.put("imprese/rel", {
        ids: selectedIds,
        pagamento: pagamentoMassivo,
      });
      toast.success(`Pagamenti aggiornati ${response.data.affectedRows}!`);
      handleClose();
      loadData();
    } catch (error) {
      toast.error("Errore durante la modifica. Riprova!");
    }
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedIds([]);
    setPagamentoMassivo({
      stato: 0,
      codice_fattura: "",
    });
    setSinistroSelected(null);
    setFiltro({ pagate: false, nonPagate: true });
  };
  const checkEmail = async () => {
    //DATI BASE
    let responseTestoEmail = await api.get("tipologie_mail/" + "Pagamento");
    let responseAmministratori = await api.get("amministratori");
    let amm = responseAmministratori.data.data?.filter(
      (el) => el.id === amministratore
    )[0];
    let responseUtenti = await api.get(
      "utenti/" + sessionStorage.getItem("Username")
    );

    //DATI LAVORI IMPRESE
    let tableData = selectedSinistri.map((lavoro) => {
      let imp = "";
      imp =
        location.state?.pagamento?.nome +
        " " +
        (lavoro?.n_fattura ? "FATT " + lavoro?.n_fattura + " " : "") +
        (lavoro?.fattura ? lavoro?.fattura + "€" : "");
      let pers = lavoro?.persone ? lavoro?.persone?.split(",") : "";
      if (pers?.length >= 3) {
        pers = pers?.slice(0, 3);
      }
      pers =
        (lavoro?.danno ? lavoro?.danno + ", " : "") +
        (pers && pers?.join(", "));
        let data = lavoro?.data_esercizio
        ? moment(lavoro?.data_esercizio).format("YY") + " "
        : "";
      let row = {
        riferimento:
          lavoro?.riferimento +
          "/" +
          data,
        condominio: lavoro?.condominio,
        impresa: imp,
        persone: pers,
      };

      return row;
    });
    setTable(tableData);

    setMail({
      ...mail,
      mittente: amm?.email ? amm.email : "",
      alias: amm?.alias_check === 1 ? amm?.alias : "",
      password: amm?.password_email ? amm.password_email : "",
      destinatari: location.state.pagamento?.email,
      copiaNascosta: responseUtenti.data?.data[0]?.copia_nascosta,
      firma: amm.firma ? amm.firma : "",
      oggetto: "Fatturazione",
      testo: responseTestoEmail.data.data[0]?.testo,
    });
    setOpenEmail(true);
  };

  const handleInputChange = (e, rowIndex, field) => {
    const updatedTable = [...table];
    updatedTable[rowIndex][field] = e.target.value;
    setTable(updatedTable);
  };

  const handleSave = async () => {
    try {
      await api.put("imprese/rel", {
        impresa: sinistroSelected,
      });
      toast.success("Modifica completata!");
      handleClose();
      loadData();
    } catch (error) {
      toast.error("Errore durante la modifica. Riprova!");
    }
  };

  const handleSendEmail = async () => {
    if (mail.destinatari) {
      setSending(true);
      try {
        await api.post("email/pagamenti/", {
          mittente: mail.mittente,
          alias: mail.alias,
          password: mail.password,
          destinatari: mail.destinatari,
          copia: mail?.copia,
          copiaNascosta: mail?.copiaNascosta,
          oggetto: mail.oggetto,
          testo: mail?.testo,
          table: table,
          firma: mail.firma,
          allegati: mail?.allegati ? [mail?.allegati] : "",
          utente: sessionStorage.getItem("Username"),
          tipologia: "Pagamento",
        });
        toast.success("Email inviata!");
      } catch (error) {
        toast.error("Errore durante l'invio!");
      }
      setSending(false);
    } else {
      toast.error("Campo Destinatari obbligatoro!");
    }
  };
  const handleCheckbox = (e) => {
    let filterUpdated = {
      ...filtro,
      [e.target.name]: e.target.checked,
    };
    setFiltro({ ...filterUpdated });
    let allImprese = sinistriBk;
    if (!filterUpdated.pagate) {
      allImprese = allImprese.filter((el) => !(el.stato === 1));
    }
    if (!filterUpdated.nonPagate) {
      allImprese = allImprese.filter((el) => el.stato === 1);
    }
    setSinistri(sortSinistriByAnnoRiferimento(allImprese));
  };
  const loadData = async () => {
    const urlParams = new URLSearchParams();
    urlParams.append("da", moment(location.state?.da).format("YYYY-MM-DD"));
    urlParams.append("a", moment(location.state?.a).format("YYYY-MM-DD"));
    urlParams.append("id", location.state?.pagamento.id);
    urlParams.append("pagante", 1);
    let responseImprese;
    if (amministratore !== 0) {
      urlParams.append("amministratore", amministratore);
      responseImprese = await api.get("pagamenti/sinistro/", {
        params: urlParams,
      });
    } else {
      urlParams.append("all", true);
      responseImprese = await api.get("pagamenti/sinistro/", {
        params: urlParams,
      });
    }
    let allImprese = responseImprese.data.data;
    if (!filtro.pagate) {
      allImprese = allImprese.filter((el) => !(el.stato === 1));
    }
    if (!filtro.nonPagate) {
      allImprese = allImprese.filter((el) => el.stato === 1);
    }
    const sorted = sortSinistriByAnnoRiferimento(allImprese);
    setSinistri(sorted);
    setSinistriBk(sortSinistriByAnnoRiferimento(responseImprese.data.data));
  };

  useEffect(() => {
    (async () => {
      loadData();
    })();
  }, []);

  return (
    <>
      <div className="page-container ">
        <div className="w-full text-center text-lg md:text-2xl ">
          {location.state?.pagamento?.nome}
        </div>
        <div className="h-full pb-4">
          <DataGridPro
            ignoreDiacritics
            rows={filteredSinistri}
            columns={columnsSinistri}
            getRowId={(row) => row.id}
            sortModel={sortModelPagamenti}
            onSortModelChange={(model) => setSortModelPagamenti(model)}
            slots={{ toolbar: CustomToolbar }}
            style={{ height: "calc(100vh - 200px)" }}
            sx={{
              minHeight: "80vh",
              "& .MuiDataGrid-footerContainer": {
                position: "sticky",
                bottom: 0,
                zIndex: 2,
                backgroundColor: "#fff",
              },
            }}
            onRowClick={(row) => {
              setSinistroSelected({ ...row.row });
              setOpen(true);
              setMassive(false);
            }}
            disableRowSelectionOnClick
            checkboxSelection
            rowSelectionModel={selectedIds}
            onRowSelectionModelChange={(ids) => {
              const selectedIDs = new Set(ids);
              setSelectedIds(ids);
              const selectedRowData = sinistri.filter((row) =>
                selectedIDs.has(row.id)
              );
              setSelectedSinistri(selectedRowData);
            }}
            initialState={{
              sorting: {
                sortModel: [
                  { field: "riferimento", sort: "desc" },
                ],
              },
            }}
          />
        </div>
        <Modal open={open} handleClose={handleClose}>
          <div className="grid grid-cols-2 gap-2">
            <div className="col-span-2 text-2xl text-center">Pagamento</div>
            <div className="col-span-2 ">
              <StatoFatturazione
                onChange={(val) => {
                  setSinistroSelected({ ...sinistroSelected, stato: val });
                  setPagamentoMassivo({ ...pagamentoMassivo, stato: val });
                }}
                value={
                  massive ? pagamentoMassivo?.stato : sinistroSelected?.stato
                }
                label={"Stato"}
              />
            </div>
            {massive ? (
              <div className="col-span-4 md:col-span-2 ">
                <Input
                  label={"Codice Fattura"}
                  type="text"
                  name="codice_fattura"
                  onChange={(e) => {
                    setPagamentoMassivo({
                      ...pagamentoMassivo,
                      codice_fattura: e.target.value,
                    });
                  }}
                  value={pagamentoMassivo?.codice_fattura}
                  icon={<HiOutlineCurrencyEuro className="text-2xl" />}
                />
              </div>
            ) : (
              <>
                <div className="col-span-4 md:col-span-2 ">
                  <Input
                    label={"Codice Fattura"}
                    type="text"
                    name="codice_fattura"
                    onChange={(e) => {
                      setSinistroSelected({
                        ...sinistroSelected,
                        codice_fattura: e.target.value,
                      });
                    }}
                    value={sinistroSelected?.codice_fattura}
                    icon={<HiOutlineCurrencyEuro className="text-2xl" />}
                  />
                </div>
                <div className="col-span-4 md:col-span-2 ">
                  <Input
                    label={"Dettaglio Pagamento"}
                    type="text"
                    name="dettaglio_pagamento"
                    onChange={(e) => {
                      setSinistroSelected({
                        ...sinistroSelected,
                        dettaglio_pagamento: e.target.value,
                      });
                    }}
                    value={sinistroSelected?.dettaglio_pagamento}
                    icon={<HiOutlineClipboard className="text-2xl" />}
                  />
                </div>
              </>
            )}
            <div className="col-span-2 flex gap-4 items-center justify-end flex-1 mt-6">
              <div
                className="icon-container-green h-min group "
                onClick={massive ? massiveUpdate : handleSave}
              >
                <HiOutlineCheck className="icon-green" />
              </div>
            </div>
          </div>
        </Modal>
        <ModalXL open={openEmail} handleClose={() => setOpenEmail(false)}>
          <div className="grid grid-cols-2 gap-2 h-full px-2">
            <div className="col-span-2 text-2xl text-center">
              Invio Pagamenti
            </div>
            <div className="col-span-2">
              <Input
                label={"Mittente"}
                type="text"
                name="mittente"
                onChange={handleChangeMail}
                value={mail?.mittente}
                icon={<HiOutlineUser className="text-2xl" />}
              />
            </div>
            {mail?.alias && (
              <div className="col-span-2">
                <Input
                  label={"Alias"}
                  type="text"
                  name="alias"
                  onChange={handleChangeMail}
                  value={mail?.alias}
                  icon={<HiOutlineUser className="text-2xl" />}
                />
              </div>
            )}
            <div className="col-span-2">
              <Input
                label={"Destinatari"}
                type="text"
                name="destinatari"
                onChange={handleChangeMail}
                value={mail?.destinatari}
                icon={<HiOutlineUser className="text-2xl" />}
              />
            </div>
            <div className="col-span-2">
              <Input
                label={"In Copia"}
                type="text"
                name="copia"
                onChange={handleChangeMail}
                value={mail?.copia}
                icon={<HiOutlineUsers className="text-2xl" />}
              />
            </div>
            <div className="col-span-2">
              <Input
                label={"In Copia Nascosta"}
                type="text"
                name="copiaNascosta"
                onChange={handleChangeMail}
                value={mail?.copiaNascosta}
                icon={<HiOutlineUsers className="text-2xl" />}
              />
            </div>
            <div className="col-span-2">
              <Input
                label={"Oggetto"}
                type="text"
                name="oggetto"
                onChange={handleChangeMail}
                value={mail?.oggetto}
                icon={<HiOutlineUsers className="text-2xl" />}
              />
            </div>

            <div className="col-span-2 ">
              <span className="text-lg font-normal">Testo</span>
              <div className="relative">
                <span className="absolute left-2 flex items-start pr-2 pt-2 h-full">
                  <HiOutlineDocumentText className="text-2xl" />
                </span>

                <textarea
                  rows={2}
                  type="text"
                  name="testo"
                  className="input flex items-center"
                  placeholder="Inserisci Testo"
                  onChange={handleChangeMail}
                  value={mail?.testo}
                />
              </div>
            </div>
            <div className="col-span-2">
              <span className="text-lg font-normal">Tabella</span>
              <table className="w-full ">
                <thead>
                  <tr>
                    <th className="border border-black">Riferimento</th>
                    <th className="border border-black">Condominio</th>
                    <th className="border border-black">Impresa</th>
                    <th className="border border-black">Persone</th>
                  </tr>
                </thead>
                <tbody>
                  {table?.map((t, rowIndex) => (
                    <tr key={rowIndex} className="border border-black h-full">
                      <td className="border border-black">
                        <input
                          type="text"
                          className="text-center w-full"
                          value={t.riferimento}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, "riferimento")
                          }
                        />
                      </td>
                      <td className="border border-black">
                        <input
                          className="text-center w-full"
                          type="text"
                          value={t.condominio}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, "condominio")
                          }
                        />
                      </td>
                      <td className="border border-black">
                        <textarea
                          type="text"
                          className="text-center w-full"
                          value={t.impresa}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, "impresa")
                          }
                        />
                      </td>
                      <td className="border border-black">
                        <textarea
                          type="text"
                          className="text-center w-full"
                          value={t.persone}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, "persone")
                          }
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="col-span-2 flex gap-4 items-center justify-end flex-1 mt-6">
              {sending ? (
                <div
                  className="icon-container-green group "
                  onClick={() => toast.warning("Invio in corso!")}
                >
                  <AiOutlineLoading3Quarters className="icon-green animate-spin" />
                </div>
              ) : (
                <div
                  className="icon-container-green h-min group "
                  onClick={handleSendEmail}
                >
                  <HiOutlinePaperAirplane className="icon-green" />
                </div>
              )}
            </div>
          </div>
        </ModalXL>
      </div>
    </>
  );
};
